import CtrlProcessoPage from './pages/CtrlProcessoPage.vue'

const routes = [
  {
    path: 'ctrl-processos',
    name: 'ctrl-processos',
    component: CtrlProcessoPage
  }
];

export default routes;